import { useState, useEffect, ReactNode, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CardV2, CardHeader, CardTitle, CardContent } from '../../../components/CardV2/CardV2';

type TimeRange = { start: string; end: string };

type TotalCardProps = {
  timeRange: TimeRange;
  title: string;
  icon: ReactNode;
  apiCall: (params: { startTime: string; endTime: string }) => Promise<{ data?: { total?: number } }>;
  description?: string;
};

const TotalCard = ({ timeRange, title, icon, apiCall, description }: TotalCardProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const apiCallRef = useRef(apiCall);

  useEffect(() => {
    apiCallRef.current = apiCall;
  }, [apiCall]);

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);
    apiCallRef.current({ 
      startTime: timeRange.start, 
      endTime: timeRange.end 
    })
      .then((res) => {
        if (!mounted) return;
        setValue(res.data?.total || 0);
      })
      .catch(() => {
        if (!mounted) return;
        setValue(0);
      })
      .finally(() => {
        if (mounted) setIsLoading(false);
      });
    return () => { mounted = false };
  }, [timeRange.start, timeRange.end]);
  
  return (
    <CardV2>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          {icon}
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="text-3xl font-bold text-foreground">...</div>
        ) : (
          <div className="text-3xl font-bold text-foreground">{value.toLocaleString()}</div>
        )}
        <p className="text-sm text-muted-foreground mt-1">
          {description || t('stats.commission_contracts.in_selected_time_range')}
        </p>
      </CardContent>
    </CardV2>
  );
};

export default TotalCard;

